import React from 'react';

export const T = {
  ink: '#0B1220',
  page: '#F4F5F8',
  card: '#FFFFFF',
  line: '#E4E7ED',
  lineSoft: '#EDEFF3',
  blue: '#007050',
  blueSoft: 'rgba(0, 112, 80, 0.08)',
  coral: '#FF6B4A',
  coralSoft: '#FFEDE7',
  green: '#16A34A',
  greenSoft: '#E9F7EF',
  slate: '#64748B',
  slateLight: '#94A1B2',
};

export const fontDisplay = "'Inter', sans-serif";
export const fontBody = "'Inter', sans-serif";
export const fontMono = "'JetBrains Mono', monospace";

export const selectStyle = {
  width: '100%',
  padding: '9px 10px',
  borderRadius: 8,
  border: `1px solid ${T.line}`,
  fontFamily: fontBody,
  fontSize: 13,
  color: T.ink,
  background: '#fff',
};

export const textareaStyle = {
  width: '100%',
  minHeight: 80,
  padding: '9px 10px',
  borderRadius: 8,
  border: `1px solid ${T.line}`,
  fontFamily: fontBody,
  fontSize: 13,
  color: T.ink,
  resize: 'vertical',
};

export function GlobalStyles() {
  return (
    <style>{`
      .sma-scroll::-webkit-scrollbar { height: 6px; width: 6px; }
      .sma-scroll::-webkit-scrollbar-thumb { background: #D7DBE3; border-radius: 4px; }
      .sma-card-hover { transition: box-shadow .18s ease, border-color .18s ease; }
      .sma-card-hover:hover { box-shadow: 0 8px 24px -8px rgba(11,18,32,0.12); border-color: #D7DBE3; }
      .sma-fade-in { animation: smaFadeIn .25s ease both; }
      @keyframes smaFadeIn { from { opacity:0; transform: translateY(4px);} to { opacity:1; transform: translateY(0);} }
      @keyframes smaSpin { to { transform: rotate(360deg); } }
    `}</style>
  );
}

export function nodeColor(kind) {
  if (kind === 'trigger') return { bg: T.blueSoft, fg: T.blue };
  if (kind === 'logic') return { bg: '#F1F2F5', fg: T.slate };
  return { bg: T.coralSoft, fg: T.coral };
}
